import type { MemberChangeLogColumns } from '@library/types/members/memberChangeLogs';
import type { TableColumn } from '@library/types/utils';

export const MEMBERS_CHANGE_LOG_HEADER: Array<
  TableColumn<MemberChangeLogColumns>
> = [
  {
    column: 'id',
    essential: true,
    label: 'ID',
    sortEnabled: false,
    width: 'basis-28'
  },
  {
    column: 'description',
    essential: true,
    label: 'Description',
    sortEnabled: false,
    width: 'basis-80'
  },
  {
    column: 'note_type',
    essential: true,
    label: 'Note Type',
    sortEnabled: false,
    width: 'basis-40'
  },
  {
    column: 'timestamp',
    essential: true,
    label: 'Timestamp',
    sortEnabled: false,
    width: 'basis-40'
  },
  {
    column: 'admin_user',
    essential: true,
    label: 'User',
    sortEnabled: false,
    width: 'basis-72'
  }
];
